module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-423.d4d2d4d.woff2";